export const ENROLMENTS_VIEW_PERMS = [
  "academy_management.admin",
  "academy_management.view",
  "academy_management.enrollments.view",
  "academy_management.enrollments.manage",
];

export const ENROLMENTS_MANAGE_PERMS = [
  "academy_management.admin",
  "academy_management.enrollments.manage",
];

export const TRIALS_MANAGE_PERMS = [
  "academy_management.admin",
  "academy_management.enrollments.manage",
  "academy_management.trials.manage",
];
